/**
 * 实体编号展示工具。
 *
 * 约定：列表 ID 列、详情页编号、关联记录引用统一带实体前缀。
 *   Contract Request -> CR-99
 *   Workorder        -> WO-111
 *   Equipment        -> EQ-111
 *   Service Request  -> SR-111
 *
 * 注意：本文件是两个前端仓库的同步件
 * （FacilityKPI-Frontend / FacilityKPI-Contract 各一份），改动必须逐字节一致。
 */

const PREFIXES = {
  contract: "CR",
  contractRequest: "CR",
  contract_request: "CR",
  serviceRequest: "SR",
  service_request: "SR",
  workorder: "WO",
  equipment: "EQ",
};

// 已经带前缀（WO-0007 / SR-1048）的值原样返回，避免叠成 WO-123。
const ALREADY_PREFIXED = /^[A-Za-z]{2,4}-/;

/**
 * 把实体 id（或编号串）格式化成带前缀的展示值。
 *
 * 幂等：输入 "#123" -> "WO-123"，输入 "WO-0007" -> "WO-0007"。
 * 后端 ContractSerializer.workorder_number 在 workordernumber 为空时会回退成
 * "#<id>"，所以幂等是必须的。
 *
 * @param {string} type 实体类型（见 PREFIXES）
 * @param {string|number|null|undefined} value
 * @param {string} fallback 空值展示
 */
export function formatEntityRef(type, value, fallback = "-") {
  if (value === null || value === undefined) return fallback;
  const raw = String(value).trim().replace(/^#\s*/, "");
  if (!raw) return fallback;

  const prefix = PREFIXES[type];
  if (!prefix) return `#${raw}`;

  if (ALREADY_PREFIXED.test(raw)) return raw;
  return `${prefix}-${raw}`;
}

export const formatContractRef = (value) => formatEntityRef("contract", value);
export const formatWorkorderRef = (value) => formatEntityRef("workorder", value);
export const formatEquipmentRef = (value) => formatEntityRef("equipment", value);
export const formatServiceRequestRef = (value) => formatEntityRef("serviceRequest", value);
